import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-14 ant-col-xl-14" }, null, -1)
const _hoisted_3 = {
  class: "ant-col ant-col-xs-5 ant-col-xl-5",
  style: {"padding-right":"5px"}
}
const _hoisted_4 = {
  class: "ant-col ant-col-xs-5 ant-col-xl-5",
  style: {"padding-right":"5px"}
}
const _hoisted_5 = {
  class: "ant-row",
  style: {"margin-top":"15px","margin-bottom":"15px"}
}
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 600,
    centered: ""
  }, {
    title: _withCtx(() => [
      _createTextVNode("Responder Requisição")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_button, {
            class: "ant-btn ant-btn-lg ant-btn-secondary",
            type: "danger",
            size: "large",
            loading: _ctx.state.negando,
            style: {"width":"100%"},
            onClick: _ctx.negar
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.state.negando ? '' : 'Negar'), 1)
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_button, {
            class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
            type: "primary",
            size: "large",
            loading: _ctx.state.autorizando,
            style: {"width":"100%"},
            onClick: _ctx.autorizar
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.state.autorizando ? '' : 'Autorizar'), 1)
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_a_form_item, {
                label: "Detalhes da Resposta",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.resposta) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.state.resposta]
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}